import { LastResultsProps } from "./types";
import dayjs from "dayjs";
import { Button, Pagination, Table } from "rsuite";
import { LastResultTable } from "../../../../interfaces/playerStats";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { exportPlayerResults } from "../../../../services/player";
import "../../playerInfo.less"
import { downloadFile } from "../../../../utils/file";
const { Column, HeaderCell, Cell } = Table;

export const LastResults = ({
  playerId,
  isFetching,
  lastResults,
  total,
  activePage,
  onChangePage,
}: LastResultsProps) => {
  const navigate = useNavigate();

  const exportMutation = useMutation({
    mutationKey: ["export-player-results"],
    mutationFn: exportPlayerResults,
  });

  const ImageCell = ({ rowData, dataKey, ...props }: any) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div className="clubs-logo-container">
        {rowData.logo && <img src={rowData.logo} className="clubs-logo" alt={rowData.name} />}
      </div>
    </Cell>
  );

  const data: LastResultTable[] = (lastResults || []).map((result) => {
    const rival = playerId === result?.away_player?.id ? result?.home_player : result?.away_player;
    const gamesRival =
      playerId === result?.away_player?.id ? result?.games_win_home : result?.games_win_away;
    const gamesHome =
      playerId === result?.away_player?.id ? result?.games_win_away : result?.games_win_home;

    return {
      id: rival.id,
      date: dayjs(result.date).format("D MMM, YYYY"),
      name: rival.name,
      logo: rival.picture,
      tournament: result.tournament_name,
      result: `${gamesHome}-${gamesRival}`,
    };
  });

  const handleExport = () => {
    if (!playerId) return;

    exportMutation.mutate(+playerId, {
      onSuccess: ({ filename, url }) => downloadFile(filename, url),
    });
  };

  return (
    <div>
      <br />
      <br />
      <br />
      <div className="header">
        <h2>Últimos enfrentamientos</h2>
        <Button appearance="primary" onClick={handleExport}>
          Descargar reporte
        </Button>
      </div>
      <Table
        autoHeight
        data={data}
        headerHeight={56}
        rowHeight={44}
        className="custom-table"
        loadAnimation
        loading={isFetching}
        onRowClick={(rowData) => navigate("/jugadores/" + rowData.id)}
        locale={{
          emptyMessage: "No se encontraron resultados",
          loading: "Cargando...",
        }}
      >
        <Column minWidth={130} flexGrow={1} align="left">
          <HeaderCell>Fecha</HeaderCell>
          <Cell dataKey="date" />
        </Column>
        <Column width={40} align="center">
          <HeaderCell>{""}</HeaderCell>
          <ImageCell dataKey="logo" />
        </Column>
        <Column minWidth={160} flexGrow={2}>
          <HeaderCell>Rival</HeaderCell>
          <Cell dataKey="name" />
        </Column>
        <Column width={200} minWidth={120} flexGrow={2} align="left">
          <HeaderCell>Torneo</HeaderCell>
          <Cell dataKey="tournament" />
        </Column>

        <Column width={110} align="center">
          <HeaderCell align="right">Resultado</HeaderCell>
          <Cell dataKey="result" />
        </Column>
      </Table>
      <br />
      <div>
        <Pagination
          prev
          last
          next
          first
          size="md"
          total={total}
          limit={10}
          activePage={activePage}
          onChangePage={onChangePage}
        />
      </div>
      <br />
    </div>
  );
};
